<div class="split-button-container" #splitButtonContainer>
  <button mat-flat-button color="primary" class="split-button-main" [matTooltip]="currentMainActionText() | translate" (click)="onMainActionClick()" [disabled]="disabled">
    <mat-icon>{{ currentMainActionIcon() }}</mat-icon>
    @if (currentMainActionText()) {
      <span>{{ currentMainActionText() | translate }}</span>
    }
  </button>
  <button mat-flat-button color="primary" class="split-button-trigger" [class.menu-open]="isMenuOpen()" #menuTrigger (click)="openSplitButtonMenu($event, splitButtonContainer)" [disabled]="disabled">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>
</div>
